import React from 'react';
import Skeleton from '@mui/material/Skeleton';

export function QrCodeDataSkeleton() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '1rem',
      }}
      className="qlf-skeleton"
    >
      <Skeleton variant="rectangular" width="12rem" height="12rem" style={{ borderRadius: 2 }} />
      <Skeleton variant="text" width="8rem" height="3rem" />
    </div>
  );
}
